// Lista módulos vinculados a un grupo.
export function modulesOfGroup(all: any[], groupId: string | null) {
    const found: any[] = [];
    for (const module of all) addGroupModule(module, found, groupId);
    return found;
}

// Agrega un módulo vinculado al grupo.
export function addGroupModule(module: any, found: any[], groupId: string | null) {
    if (linkedToGroup(module, groupId)) found.push(module);
}

// Revisa vínculos del módulo con el grupo.
export function linkedToGroup(module: any, groupId: string | null) {
    for (const link of (module.groupModules || [])) {
        if (groupLinkMatches(link, groupId)) return true;
    }
    return false;
}

// Compara un vínculo de grupo.
export function groupLinkMatches(link: any, groupId: string | null) {
    if (link.groupId === groupId) return true;
    return groupRefMatches(link.group, groupId);
}

// Compara la referencia de grupo.
export function groupRefMatches(group: any, groupId: string | null) {
    if (group) return group.id === groupId;
    return false;
}

// Mapea auditores actuales de la entidad.
export function currentAuditors(entity: any) {
    const found = new Map();
    for (const link of (entity?.entityModules || [])) putAuditor(found, link);
    return found;
}

// Guarda el auditor de un vínculo.
export function putAuditor(found: Map<string, any>, link: any) {
    if (link.moduleId) found.set(link.moduleId, auditorOf(link));
}

// Lee el id de auditor de un vínculo.
export function auditorOf(link: any) {
    if (link.auditorId) return link.auditorId;
    return auditorIdOrNull(link.auditor);
}

// Lee el id de auditor con nulo.
export function auditorIdOrNull(auditor: any) {
    if (auditor) return auditor.id || null;
    return null;
}

// Siembra auditores faltantes por módulo.
export function seedAuditors(current: Record<string, any>, modules: any[], existing: Map<string, any>) {
    for (const module of modules) seedAuditor(current, module, existing);
}

// Siembra el auditor de un módulo.
export function seedAuditor(current: Record<string, any>, module: any, existing: Map<string, any>) {
    if (module.id in current) return;
    current[module.id] = existing.get(module.id) || null;
}

// Poda auditores fuera de módulos.
export function pruneAuditors(current: Record<string, any>, modules: any[]) {
    for (const key of Object.keys(current)) dropAuditor(current, modules, key);
}

// Elimina el auditor del módulo ausente.
export function dropAuditor(current: Record<string, any>, modules: any[], key: string) {
    if (hasModuleId(modules, key)) return;
    delete current[key];
}

// Revisa si el id de módulo existe.
export function hasModuleId(modules: any[], id: string) {
    for (const module of modules) {
        if (module.id === id) return true;
    }
    return false;
}

// Mapea auditores actuales como registro.
export function auditorRecord(entity: any) {
    const record: Record<string, any> = {};
    for (const link of (entity?.entityModules || [])) addRecordAuditor(record, link);
    return record;
}

// Agrega el auditor de un vínculo.
export function addRecordAuditor(record: Record<string, any>, link: any) {
    record[link.moduleId] = auditorOf(link);
}
